<mat-form-field
  [subscriptSizing]="input.subscriptSizing"
  [appearance]="input.appearance"
>
  @if (input.label | parse: context | async; as label) {
    <mat-label>{{ label }}</mat-label>
  }
  <input
    [type]="hide ? (input.fieldType | parse: context | async) : 'text'"
    matInput
    [formControl]="_formControl"
    [placeholder]="input.placeholder | parse: context | async"
    [required]="input.required"
    [readonly]="input.readonly | parse: context | async"
    (blur)="onBlur($event)"
    (keydown.enter)="onEnter()"
  />
  @if (input.fieldType === 'password') {
    <button
      mat-icon-button
      matSuffix
      (click)="hide = !hide"
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hide"
    >
      <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
  }
  @if (firstFormControlError; as error) {
    <mat-error>
      {{ error.errorMessage | parse: context | async }}
    </mat-error>
  }
</mat-form-field>
